import { render, staticRenderFns } from "./InstagramStarSummaryCard.vue?vue&type=template&id=2cb32d95&scoped=true"
import script from "./InstagramStarSummaryCard.vue?vue&type=script&lang=js"
export * from "./InstagramStarSummaryCard.vue?vue&type=script&lang=js"
import style0 from "./InstagramStarSummaryCard.vue?vue&type=style&index=0&id=2cb32d95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb32d95",
  null
  
)

export default component.exports